import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { Card, Modal } from "react-bootstrap";
import LoginModal from "../@ui/LoginModal";
import logoImage from "../assets/login/login-logo.png";
import { useTenantContext } from "../context/Tenant/TenantContext";

const LoginPane = styled.div<{ fullWidth: boolean }>`
  width: ${(props) => (props.fullWidth ? "100%" : "50%")};
  min-width: 480px;
  padding: 10px;
`;

const LoginCard = styled(Card)`
  border: none;
  dispay: flex;
  flex-direction: column;
  height: 100%;
`;

const LoginDL = styled.dl`
  dt {
    color: var(--bs-link-color);
    font-size: 1.2em;
  }
  dd {
    font-weight: normal;
  }
`;

const LoginLayout = () => {
  const location = useLocation();
  const showHomePanel = location.pathname.toLocaleLowerCase() === "/login";
  const config = useTenantContext().config;

  return (
    <>
      <LoginModal show={true} size={showHomePanel ? "xl" : undefined} centered>
        <div className="d-flex justify-content-center flex-wrap">
          {showHomePanel && (
            <LoginPane fullWidth={false}>
              <LoginCard>
                <Modal.Header className="bg-secondary text-white d-flex justify-content-between">
                  <Modal.Title>
                    Welcome {config.name !== "Inrix" ? "to DataCutter" : ""}
                  </Modal.Title>
                  {config.name === "Inrix" ?
                    <img
                      style={{ height: "20px" }}
                      src={config.mainLogo}
                      alt="DataCutter"
                    />
                  : <img
                      className="w-25"
                      src={config.mainLogo}
                      alt="DataCutter"
                    />
                  }
                </Modal.Header>
                <Modal.Body>
                  {config.name === "Inrix" ?
                    <p>
                      Unlock a wide range of INRIX datasets, including detailed
                      traffic volumes, average and percentile speeds, and
                      Trips/Origin-Destination data. Simply draw your own map
                      boundary and download high-quality INRIX road and movement
                      datasets for any location—quickly, effortlessly, and ready
                      for analysis.
                    </p>
                  : <p>
                      Unlock a wide range of datasets, including public
                      transport data, points of interest (POI), bus routes, road
                      networks, and census data. Simply draw your own map
                      boundary and download high-quality datasets for any
                      location in the world—quickly and effortlessly.
                    </p>
                  }
                  <LoginDL>
                    <dt>Customised Data Selection</dt>
                    <dd>
                      Draw your own map boundary or choose from predefined areas
                      within DataCutter for precise, location-specific datasets.
                    </dd>
                    <dt>Time-Saving & Ready to Use</dt>
                    <dd>
                      Instant access to a wide range of datasets in a
                      ready-to-use format, eliminating the need for complex data
                      processing.
                    </dd>
                    <dt>Flexible & Secure Payment</dt>
                    <dd>
                      Easily purchase data online with a credit card through a
                      secure checkout.
                    </dd>
                    <dt>Cost-Effective</dt>
                    <dd>
                      Only pay for the data you need—no unnecessary extras.
                    </dd>
                  </LoginDL>
                  <a
                    href="/boundaries"
                    className="btn btn-primary me-2"
                    role="button"
                  >
                    Pre-defined Boundaries
                  </a>
                  <a href="/datasets" className="btn btn-primary" role="button">
                    Available Datasets
                  </a>
                </Modal.Body>
              </LoginCard>
            </LoginPane>
          )}
          <LoginPane fullWidth={!showHomePanel}>
            <LoginCard>
              <Outlet />
            </LoginCard>
          </LoginPane>
        </div>
      </LoginModal>
    </>
  );
};

export default LoginLayout;
